import { ReactNode } from "react";
import { Icon } from "@/shared/ui";
import CarouselSlider from "@/shared/widgets/CarouselSlider";

type Props = {
  src?: string;
  level?: string;
  list?: unknown[];
  activeIndex?: number;
  setActiveIndex?: (index: number) => void;
  leftText?: ReactNode;
  rightText?: ReactNode;
  children?: ReactNode;
  isLoading?: boolean;
};
export default function OfferView({
  src,
  level,
  list,
  activeIndex,
  setActiveIndex,
  leftText,
  rightText,
  children,
  isLoading,
}: Props) {
  return (
    <CarouselSlider
      src={src}
      list={list}
      activeIndex={activeIndex}
      setActiveIndex={setActiveIndex}
      classNameContainer="h-[14.8125rem]"
      isHideButtons={!list || list.length < 2}
    >
      {isLoading && (
        <div className="absolute z-3 top-1/2 left-1/2 flex items-center justify-center p-4 -translate-x-1/2 -translate-y-1/2">
          <div className="mz-loader" />
        </div>
      )}
      {level && (
        <div className="absolute top-4 left-4 bg-white h-[1.5rem] flex items-center gap-1 uppercase leading-none text-[#0F0F0F] text-12 font-bold rounded-[0.3125rem] pl-1.5 pr-2">
          <Icon category="home-menu" name="star" className="w-3.5" />
          {level}
        </div>
      )}
      {(leftText || rightText) && (
        <div
          className="flex items-center gap-2.5 w-full h-16 mt-auto p-4 bg-[linear-gradient(180deg,rgba(18,18,18,0.3)_0%,rgba(18,18,18,0.6)_100%)] rounded-b-4"
          style={{ backdropFilter: "blur(5px)" }}
        >
          {leftText}
          {rightText}
        </div>
      )}
      {children}
    </CarouselSlider>
  );
}
